import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectDetailsTileLabel: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.project-details-tile-label',
		defaultMessage: 'Project',
		description: 'Text for project tile icon',
	},
	projectDetailsTileHeading: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.project-details-tile-heading',
		defaultMessage: '1 Jira project: {projectName}',
		description: 'Title of Project Details tile',
	},
	projectDetailsTileDescription: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.project-details-tile-description',
		defaultMessage: 'A {projectStyle} {projectType} project{projectTemplate} will be created',
		description: 'Description of Project Details tile',
	},
	fieldTileLabel: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-label',
		defaultMessage: 'Fields',
		description: 'Text for field tile icon',
	},
	fieldTileHeading: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-heading',
		defaultMessage: '{numOfImported}/{numOfTotal} {numOfTotal, plural, one {field} other {fields}}',
		description: 'Title of Field Details tile',
	},
	fieldTileDescription: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-description',
		defaultMessage:
			'{numOfExistingFields} {numOfExistingFields, plural, one {column} other {columns}} will be mapped to existing Jira fields',
		description: 'Description of Field Details tile',
	},
	fieldTileDescriptionForCustomField: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-description-for-custom-field',
		defaultMessage:
			' and {numOfCustomFields} {numOfCustomFields, plural, one {custom field} other {custom fields}} will be created',
		description: 'Description of Field Details tile',
	},
	usersTileLabel: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-label',
		defaultMessage: 'Users',
		description: 'Text for Users tile icon',
	},
	usersTileHeading: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-heading',
		defaultMessage: '{numOfUniqueImported} {numOfUniqueImported, plural, one {user} other {users}}',
		description: 'Title of User Details tile',
	},
	usersTileDescription: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-description',
		defaultMessage:
			'{numOfImported}/{numOfTotal} {numOfTotal, plural, one {user row} other {user rows}} have been mapped.',
		description: 'Description of User Details tile',
	},
	usersTileMoreDescription: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-more-description',
		defaultMessage:
			'{numOfUniqueImported} {numOfUniqueImported, plural, one {unique user} other {unique users}} will be moved to Jira.',
		description: 'Description of User Details tile',
	},
	noUsersTileTitle: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.no-users-tile-title',
		defaultMessage: 'No users',
		description: 'Title of no user imported',
	},
	noUsersTileDescription: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.no-users-tile-description',
		defaultMessage:
			'You haven’t added users to the project. Assignee and reporter fields will be unassigned and user @mentions in comments will be converted to plain text.',
		description: 'Description of no user imported',
	},
	issuesTileLabel: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.issues-tile-label',
		defaultMessage: 'Issues',
		description: 'Text for issues tile icon',
	},
	issuesTileHeading: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.issues-tile-heading',
		defaultMessage: '{numOfIssue} {numOfIssue, plural, one {issue} other {issues}}',
		description: 'Title of issues tile',
	},
	issuesTileDescription: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.issues-tile-description',
		defaultMessage:
			'Each row of the CSV data will be imported as an issue. <link>What is an issue?</link>',
		description: 'Description of issues tile',
	},
	noIssuesTileDescription: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.no-issues-tile-description',
		defaultMessage:
			'The CSV file doesn’t contain any data. Upload a CSV file with your team’s data to import them as an issue. <link>What is an issue?</link>',
		description: 'Description for no issue imported',
	},
	business: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.business',
		defaultMessage: 'business',
		description: 'Name for Business Project Type',
	},
	software: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.software',
		defaultMessage: 'software',
		description: 'Name for Software Project Type',
	},
	cmp: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.cmp',
		defaultMessage: 'company-managed',
		description: 'Name for Company Managed Project Style',
	},
	tmp: {
		id: 'project-create-importer-upload-flow.review-screen-standard.review-tiles.tmp',
		defaultMessage: 'team-managed',
		description: 'Name for Team Managed Project Style',
	},
});
